<template>
  <div>

    <b-modal id="modalGeneralCommentsPQsComponentId" size="lg"
      title="Comentar productos en masivo." scrollable centered
      no-close-on-backdrop no-close-on-esc no-enforce-focus no-fade header-close-content="">

      <!-- Opciones -->
      <b-form-group>
        <label for="productsAction">Productos a comentar</label>
        <br />
        <el-select id="productsAction" name="productsAction" v-model="productsAction">
          <el-option v-for="item in actionsInProducts" :key="item.id" :label="item.text"
            :value="item.id" />
        </el-select>
      </b-form-group>

      <!-- Selección específica de productos -->
      <b-form-group v-if="productsAction == 3">
        <filterProductsFilledComponent
          :onRemoteMethod="onHandleChangeProducts"
          :onSelected="onHandleSelectedProductsFilled"
          :onTrashSelected="onHandleTrashSelectedProduct"
          :itemsSelecteds="selectedProductsFilled"
          messageInfo="No hay productos seleccionados."
        />
      </b-form-group>

      <!-- Comentario -->
      <div>
        <label for="comment">Comentario</label>
        <b-form-textarea id="comment" v-model="comment" placeholder="Comentarios"
          rows="4" max-rows="6" maxLength="255" minLength="1"></b-form-textarea>
        <div class="d-flex justify-content-end">
          <span class="text-xs small text-gray">{{ comment.length }} de 255 caracteres</span>
        </div>
      </div>

      <!-- Footer -->
      <template #modal-footer>

        <b-button variant="primary" @click="onHandleOk()" :disabled="isDisabledBtnOk">
          <span v-if="!loading">
            <i class="fa fa-floppy-o"></i> 
            Guardar
          </span>
          <span v-else>Por favor, espera...</span>
        </b-button>

        <b-button variant="light" @click="onHandleCancel()" :disabled="loading">
          <span v-if="!loading">Cancelar</span>
          <span v-else>Cancelando...</span>
        </b-button>

      </template>

    </b-modal>

  </div>
</template>

<script>

// Generales
import { mapState, mapActions } from 'vuex';

// Componentes
import filterProductsFilledComponent from '../../FilterProductsFilled.vue'

export default {
  name: 'modalGeneralComments',
  props: {
    confirmAction: {
      type: Function,
      default: () => { }
    },
    actionCancel: {
      type: Function,
      default: () => { }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    filterProductsFilledComponent
  },
  data: function () {
    return {
      comment: '',
      actionsInProducts: [
        {id: 1, text: 'Productos de la página actual'},
        {id: 2, text: 'Todos los productos'},
        {id: 3, text: 'Seleccionar productos específicos'},
      ],
      productsAction: 1,
      selectedProductsFilled: []
    };
  },
  computed: {
    ...mapState('assignPQTraceable', [
      'actionToTraceablePQ'
    ]),
    getProductsId() {
      return this.selectedProductsFilled.map(x => x.id);
    },
    isDisabledBtnOk() {
      if (this.loading || this.comment.length <= 0) return true;
      
      if ((!this.getProductsId || this.getProductsId.length <= 0) && this.productsAction == 3) return true;

      return false;
    }
  },
  methods: {
    ...mapActions('productsSearch', [
      'filterProductsFilledInByName'
    ]),
    onHandleOk() {
      if (this.comment.length <= 0) {
        this.$vue.$alertError("El campo comentario es obligatorio.");
        return false;
      }

      if (this.comment.length > 255) {
        this.$vue.$alertError("El campo comentario no debe contener mas de 255 caracteres.");
        return false;
      }

      this.confirmAction({
        comment: this.comment, 
        productsAction: this.productsAction,
        selectedProductsFilled: this.getProductsId
      }).then(() => {
        this.comment = ""
        this.selectedProductsFilled = []
      })
    },
    onHandleCancel() {
      this.actionCancel();
      this.comment = "";
      this.selectedProductsFilled = []
    },
    /**
     * Controlar cambios en el select de buscar productos.
     *
     * @author Fernando Claros
     */
    async onHandleChangeProducts(value) {

      await this.filterProductsFilledInByName({
        company_id: this.$route.params.id,
        product_param: value
      });

    },
    /**
    * Seleccionar y agregar el producto a la lista.
    *
    * @author Fernando Claros
    */
    onHandleSelectedProductsFilled(lists) {
      this.selectedProductsFilled = lists
    },
    /**
    * Eliminar el producto de la lista.
    *
    * @param {Array} lists
    * @author Fernando Claros
    */
    onHandleTrashSelectedProduct(lists) {
      this.selectedProductsFilled = lists
    },
  }
};
</script>